<template>
	<div>
		<div class="cover" ref="cover" v-show="!chooseToDisappear">
			<div class="notice-bg">
				<div id='tip-container'>
				  <img src="../assets/searchTipTitle.png" id='search-tip-title'/>
				  <div class='tip'><div class='tip-no'>1</div><div class='tip-content'>可搜索证件照规格名称，如“签证”</div></div>
				  <div class='tip'><div class='tip-no'>2</div><div class='tip-content'>可搜索像素大小，如“413”</div></div>
				  <div class='tip'><div class='tip-no'>3</div><div class='tip-content'>可搜索纸质照片尺寸，如“35”</div></div>
				  <div class='tip'><div class='tip-no'>4</div><div class='tip-content'>可搜索文件大小，如“100”</div></div>
				  <div id='close-tip' @click="closeTip">我知道了</div>
				</div>
			  </div>
		</div>
		<div class="realPage">
			<div class="search-area">
				<div class='search-inner-area'>
			   <img src='../assets/icon_search.png' class="search-icon" ></img>
				<div class="search-txt-area">
				  <input :placeholder="defaultSearchValue" v-model="searchWord" @keyup.enter="searchByTap(searchWord || defaultSearchValue)" class="search-txt"/>
				</div>
				<img src='../assets/icon_del.png' class="search-close" @click="clear"></img>
				</div>
				<div class='cancel' @click="cancel">取消</div>
			 </div>
			<div class="marginFixed">
				<!-- 历史搜索 -->
				<div v-if="!searchResults" class="searchItems">
					<div class="searchItemList" v-if="historySearch">
						<div class="item-title">
							<span>历史搜索：</span>
							<div class="title-img" @click="delHistory">
								<svg viewBox="0 0 512 512" id="bin" width="100%" height="100%">
									<path d="M64 160v320c0 17.6 14.4 32 32 32h288c17.6 0 32-14.4 32-32V160H64zm96 288h-32V224h32v224zm64 0h-32V224h32v224zm64 0h-32V224h32v224zm64 0h-32V224h32v224zM424 64H320V24c0-13.2-10.8-24-24-24H184c-13.2 0-24 10.8-24 24v40H56c-13.2 0-24 10.8-24 24v40h416V88c0-13.2-10.8-24-24-24zm-136 0h-96V32.401h96V64z"></path>
								</svg>
							</div>
						</div>
						<ul>
							<search-word v-for="(word, key) in historySearch" :searchWord="word" :key="key" @searchThisItem="searchByTap">
							</search-word>
						</ul>
					</div>

					<!-- 热门搜索 -->
					<div class="searchItemList">
						<div class="item-title">
							<span>热门搜索：</span>
						</div>
						<div class="hot-search-open-tip" @click="openTip">如何搜索？</div>
						<ul>
							<search-word v-for="(word, key) in hotSearch" :searchWord="word" :key="key" @searchThisItem="searchByTap">
							</search-word>
						</ul>
					</div>
				</div>
				<div class="searchResultList" v-else>
					<!--搜索没有结果的情况下，显示的界面-->
					<div v-if="noResult">
						<div class="no-result">
							<img src="../assets/no_result.png"></img>
							<div id='no-result-tip'>没有找到你要的证件照规格</div>
							<div id='no-result-open-tip' @click="openTip">点击查看搜索教程</div>
						 </div>
					</div>
					<!--搜索有结果的情况下，显示结果-->
					<div v-else>
						<result-items v-for="item in searchResults" :item="item" :key="item.specs_id" @showDetailInfo="showSpecDetail">
						</result-items>
					</div>
				</div>
			</div>

		</div>
		

	</div>
</template>

<script>
	import { mapMutations, mapState, mapActions } from "vuex";
	import { config } from "@/config/config";
	import SearchWord from "@/components/SearchWord";
	import ResultItems from "@/components/SearchResultItem";
	import { historySearch } from "@/utils/utils";
	import { searchByKeywords } from "@/data/api";

	export default {
		components: {
			SearchWord,
			ResultItems
		},
		data() {
			return {
				searchWord: null,
				defaultSearchValue: "美国签证", //默认搜索值
				historySearch: null, //历史搜索
				noResult: false, //结果集长度
				chooseToDisappear:true
			};
		},
		methods: {
			...mapMutations(["RECORD_SPECINFO", "RECORD_SEARCH_RESULTS", "RECORD_LAST_SEARCH"]),
			...mapActions(['getHotSearch']),
			delHistory() {
				this.historySearch = null;
				historySearch.delete();
			},
			//record search value by enter or tab list item
			searchByTap(keyWord) {
				ap.showLoading({
					content: '搜索中'
				});
				let keyWord_s = keyWord.toString();
				historySearch.add(keyWord_s);
				this.historySearch = historySearch.getHistorySearchData();
				this.search(keyWord_s);
			},
			search: function(keyWord) {
				this.searchWord = keyWord;
				searchByKeywords(keyWord)
					.then(({
						data: {
							specs
						}
					}) => {
						this.RECORD_LAST_SEARCH(keyWord);
						this.RECORD_SEARCH_RESULTS(specs);
						console.log(specs);
						if(specs.length == 0) {
							this.noResult = true;
						} else {
							this.noResult = false;
						}
					})
					.catch(error => {
						//deal with error
						console.log(error);
					})
					.then(() => {
						ap.hideLoading();
					});
			},
			showSpecDetail: function(specInfo) {
				this.RECORD_SPECINFO(specInfo);
				//navigator to photo-making page
				this.$router.push({
					name: "spec"
				});
			},
			clear:function() {
				this.searchWord=null;
			},
			cancel:function(){
				this.$router.go(-1);
			},
			openTip:function() {
				this.$refs.cover.style.display = 'inline';
			},
			closeTip: function() {
				this.$refs.cover.style.display = 'none';
			}
		},
		created() {
			ap.setNavigationBar({
				title: '搜索证件照规格'
			});
			this.$ba.trackPageview('search');
			this.getHotSearch();
			if(this.lastSearchWord) {
				this.searchWord = this.lastSearchWord;
			}
			this.historySearch = historySearch.getHistorySearchData();
		},
		beforeMount() {

		},
		computed: {
			...mapState(["searchResults", "lastSearchWord", "hotSearch"]),
		},

		watch: {
			//当searchValue没有值，清空搜索结果（清除搜索结果，再输入的时候，不能出现上次的搜索结果）
			searchWord(val) {
				if(!val) {
					this.RECORD_LAST_SEARCH(val);
					this.RECORD_SEARCH_RESULTS(null);
				}
			}
		}
	};
</script>

<style lang="scss" scoped>
	.realPage {
		height: 100vh;
	}
	
	.item-title {
		display: flex;
		justify-content: space-between;
		align-items: center;
		font-weight: 700;
		margin-bottom: 20px;
		color: #666666;
		font-size: 13px;
	}
	
	.title-img {
		width: 12px;
	}
	
	.searchItemList {
		padding: 12px 15px;
		background-color: #ffffff;
		position: relative;
	}
	
	//默认height100%占了一页
	.mint-search {
		height: auto;
		width: 100%;
		position: fixed;
		top: 0;
	}
	
	.hot-search-open-tip{
	  position: absolute;
	  font-size: 12px;
	  color:#999999;
	  top: 15px;
	  right: 20px;
	}
	
	.searchItems {
		background-color: #ffffff;
	}
	
	.no-result{
	  text-align: center;
	  background-color: #FFF;
	  padding: 28.125px;
	}
	.no-result image{
	  width: 88px;
	  height: 80px;
	  margin-bottom: 9.375px
	}
	#no-result-tip{
	  font-size: 15px;
	  margin: 5.625px 0;
	  color:#999999;
	  font-size: 12px; 
	}
	#no-result-open-tip{
	  width:160px;
	  height:36px;
	  background:rgba(255,246,232,1);
	  border-radius:18px;
	  border:1px solid rgba(245,166,35,1);
	  font-size:13px;
	  color:rgba(245,166,35,1);
	  line-height:36px;
	  margin:  20px auto;
	}
	
	.cover {
		padding: 0;
		margin: 0;
		z-index: 10;
		position: absolute;
		top: 0%;
		left: 0%;
		width: 100vw;
		height: 100vh;
		background: rgba(0, 0, 0, 0.8);
	}
	
	#tip-container{
	  width: 300px;
	  height: 330px;
	  margin:119px auto;
	  background:rgba(255,255,255,1);
	  border-radius:4px;
	}
	#search-tip-title{
	  width: 300px;
	  height: 90px;
	  margin-bottom: 24px;
	//   background: url("../assets/searchTipTitle.png") no-repeat;
	//   background-size: cover;
	}
	.tip{
	  width: 260px;
	  margin: auto;
	  margin-bottom: 10px;
	}
	.tip-no{
	  width:27px;
	  height:27px;
	  background:rgba(255,255,255,1);
	  box-shadow:0px 2px 4px 0px rgba(82,84,255,0.14);
	  border-radius: 50%;
	  font-size:15px;
	  color:rgba(68,128,231,1);
	  line-height:27px;
	  text-align: center;
	  display: inline-block;
	}
	.tip-content{
	  width:218px;
	  margin-left: 15px;
	  display: inline-block;
	  font-size:14px;
	  color:rgba(102,102,102,1);
	  line-height:27px;
	}
	#close-tip{
	  width:250px;
	  height:44px;
	  background:rgba(68,128,231,1);
	  border-radius:22px;
	  font-size:16px;
	  line-height: 44px;
	  color:rgba(255,255,255,1);
	  text-align: center;
	  margin-left: 24px;
	  margin-top: 10px;

	}

	.search-area{
	  background-color: #4480E7;
	  padding: 9.375px 18.75px; 
	  overflow: hidden;
	  display:flex;
	  align-items: center;
	  justify-content: space-between;
	  height: 55px;
	  box-shadow:0px 6px 8px 0px rgba(236,236,236,0.5);
	}
	.search-inner-area{
	  width: 80vw;
	  height: 38px;
	  border-radius:4px;
	  background:rgba(255,255,255,1);
	  display: flex;
	}
	.cancel{
	  width: 31px;
	  height: 21px;
	  color: #FFF;
	  font-size: 15px;
	  position: relative;
	  left: 5px;
	}
	.search-icon{
	  height: 18px;
	  width: 18px;
	  margin: 10px 0 10px 19px;
	  display: inline-block;
	}
	.search-txt{
	  font-size: 14px;
	  line-height: 22px;
	  height: 22px;
	  width:195px;
	  border: none;
	}
	.search-txt-area{
	  display: inline-block;
	  margin: 8px 0 8px 10px;
	  background: #FFF;
	  width: 215px;
	}
	.search-close{
	  height: 15px;
	  width: 15px;
	  margin:11.5px 18px 11.5px 5px;
	  display: inline-block;
	}
</style>